import { isUndefined } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

/**
* ProblemLinkingFeedbackHelper.js
* 
* Created on 5-nov-2013
*
* @author Olivier van der Pool for Ranj
**/
export default class ProblemLinkingFeedbackHelper {
    constructor() {
    }
    /**
        * Handles problem linking results logic.
        * @param {ProblemModel} playerModel The model containing the player input from the problem linking mediator.
        * @param {ProblemModel} correctModel The correct problemModel (as it is stored in the Scenario object) to compare the player model to.
        * @param {Function} onSolutionFeedback The function to call after the player submitted solution feedback is handled. Params: (result, playerSolution, correctSolution, problem)
        * @param {Function} onArgumentFeedback The function to call when a player submitted argument supports the correct solution. Params: (result, argument, problem)
        * @param {Function} onMissingArgument The function to call for each argument that supports the correct solution but was not submitted by the player. Params: (argument, problem)
        */
    handleFeedback(playerModel, correctModel, onSolutionFeedback, onArgumentFeedback, onMissingArgument) {
        var problems = playerModel.getProblems();

        //loop through all problems submitted by the user and compare them to the correct model
        for (var i = 0; i < problems.length; i++) {
            var playerProblem = problems[i];
            var correctProblem = correctModel.getProblemByID(playerProblem.getID());

            var playerSolution = playerProblem.getSolutions()[0];
            var correctSolution = correctProblem.getCorrectSolution();

            if (playerSolution.getID() === correctSolution.getID()) {
                //player solution is correct
                if (!isUndefined(onSolutionFeedback))
                    onSolutionFeedback(true, playerSolution, correctSolution, correctProblem);
            } else {
                //player solution is incorrect
                if (!isUndefined(onSolutionFeedback))
                    onSolutionFeedback(false, playerSolution, correctSolution, correctProblem);
            }

            var playerArguments = playerSolution.getArguments();
            for (var i2 = 0; i2 < playerArguments.length; i2++) {
                if (correctSolution.isArgumentCorrect(playerArguments[i2].getID())) {
                    //the argument is correct
                    if (!isUndefined(onArgumentFeedback))
                        onArgumentFeedback(true, playerArguments[i2], correctProblem);
                } else {
                    if (!isUndefined(onArgumentFeedback))
                        onArgumentFeedback(false, playerArguments[i2], correctProblem);
                }
            }

            var correctArguments = correctSolution.getArguments();
            for (i2 = 0; i2 < correctArguments.length; i2++) {
                if (playerSolution.getArgumentByID(correctArguments[i2].getID()) === null) {
                    //the correct argument is not contained in the player solution
                    if (!isUndefined(onMissingArgument))
                        onMissingArgument(correctArguments[i2], correctProblem);
                }
            }
        }
    }
}



